import { render } from "./TextbookHeadTitle.vue?vue&type=template&id=559c4720&scoped=true"
import script from "./TextbookHeadTitle.vue?vue&type=script&lang=js"
export * from "./TextbookHeadTitle.vue?vue&type=script&lang=js"

import "./TextbookHeadTitle.vue?vue&type=style&index=0&id=559c4720&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559c4720"]])

export default __exports__